module.exports = __webpack_public_path__ + "img/video6.56bdbec9.jpg";